import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', function() {
    const cssSlider = document.querySelectorAll('.cyber-security-slider');

    cssSlider.forEach(section => {
        const mainSliderEl = section.querySelector('.cyberSwiper');
        const thumbSliderEl = section.querySelector('.cyberSwiper-thumb');

        // RIGHT slider (only used to display NEXT title, no sliding needed)
        const thumbSlider = new Swiper(thumbSliderEl, {
            allowTouchMove: false,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            loop: true,
            slidesPerView: 1,
        });

        // LEFT slider (main content slider)
        new Swiper(mainSliderEl, {
            loop: true,
            slidesPerView: 1,
            spaceBetween: 30,
            autoplay: {
                delay: 3000,
            },
            pagination: {
                el: section.querySelector('.swiper-pagination'),
                clickable: true,
            },
            breakpoints: {
                0: {
                    autoHeight: true,
                },
                992: {
                    autoHeight: false,
                },
            },
            on: {
                init(swiper) {
                    updateRightTitle(swiper, thumbSlider);
                },
                slideChange(swiper) {
                    updateRightTitle(swiper, thumbSlider);
                },
            },
        });
    });

    function updateRightTitle(main, thumb) {
        const realIndex = main.realIndex;
        const nextIndex = (realIndex + 1) % main.slides.length;

        // Move the thumb slider to the NEXT index
        thumb.slideToLoop(nextIndex);
    }
});
